import { Table, TableColumn, Select, Option } from 'element-ui';
import { Pagination as LPagination } from '@/components/index';
import AdminCourseTypeSelect from '@/components/admin/courses/course-type-select/course-type-select.vue';
import ResourceSvc from '@/services/resource.svc.js';

const svc = new ResourceSvc();

export default {
    title: "",
    props: ['status'],
    name: 'AdminCoursesTab',
    components: {
        LPagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        AdminCourseTypeSelect
    },
    computed: {
        pagedData() {
            return this.tableData.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            if (this.tableData.length == 0 ) {
                return 0;
            }
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            this.pagination.total = this.count;
            return this.count;

        },
        currentTypeId() {
            return this.typeId;
        }
    },
    watch: {
        currentTypeId: function (newId) {
            this.queriedData();
        }
    },
    data() {
        return {
            isForcedLoad: false,
            dataLoad: false,
            typeId: 0,
            savedSearchQuery: '',
            savedCurrentTypeId: 0,
            searchTimeout: null,
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0,
                savedPageIndex: 0,
                savedPerPage: 0
            },
            searchQuery: '',
            propsToSearch: ['name', 'email', 'age'],
            tableColumns: [],
            tableData: [],
            count: 0
        };
    },
    methods: {
        queriedData(forced) {
            var self = this;

            if (this.searchQuery !== this.savedSearchQuery && !this.isForcedLoad && !forced) {

                if (this.searchTimeout) {
                    return this.tableData;
                }
                else {
                    this.searchTimeout = setTimeout(function () { self.searchTimeout = null; self.queriedData(true); }, 750);
                    return this.tableData;
                }
            }

            if (this.dataLoad)
                return this.tableData;
            if (this.pagination.savedPageIndex === this.pagination.currentPage && this.pagination.perPage === this.pagination.savedPerPage &&
                this.searchQuery === this.savedSearchQuery && this.savedCurrentTypeId == this.currentTypeId && !this.isForcedLoad)
                return this.tableData;

            this.isForcedLoad = false;

            var conf = { typeId: this.currentTypeId, status: this.status, take: this.pagination.perPage, skip: this.from, search: this.searchQuery };
            if (conf.skip < 0) {
                conf.skip = 0;
            }

            while (this.pagination.total <= conf.skip && conf.skip) {
                this.pagination.currentPage--;
                conf.skip -= this.pagination.perPage;
                if (conf.skip < 0) {
                    conf.skip = 0;
                }
            }
            this.dataLoad = true;

            svc.getCourses(conf).then(response => {
                self.dataLoad = false;
                if (response.body == null) {
                    return;
                }
                    
                self.tableData = response.body.data;
                self.count = response.data.count;
                self.pagination.savedPageIndex = self.pagination.currentPage;
                self.pagination.savedPerPage = self.pagination.perPage;
                self.savedSearchQuery = self.searchQuery;
                self.savedCurrentTypeId = self.currentTypeId;
                if (self.count == 0) {
                    self.pagination.from = -1;
                }
                else {
                    self.pagination.to = self.pagination.currentPage * self.pagination.perPage;
                    self.pagination.from = self.pagination.to - self.pagination.perPage;
                }
                return self.tableData;
            }, response => {
                //todo add interseptor
                self.tableData = [];
                self.pagination.savedPageIndex = self.pagination.currentPage;
                self.pagination.savedPerPage = self.pagination.perPage;
                self.savedSearchQuery = self.searchQuery;
                self.savedCurrentTypeId = self.currentTypeId;
                self.dataLoad = false;
                self.pagination.from = -1;
                return [];
            });
        },
        updateData() {
            this.$refs.statusSelect.reload();
            var that = this;
            setTimeout(function () {
                that.isForcedLoad = true;
                that.pagination.currentPage = 1;
                that.queriedData();
            }, 700);
        }
    },
    created() {
        this.title = this.status == 1 ? "Pending table" : "Completed table";
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/courses/courses-tab/courses-tab.js